function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["breakpoints", "className", "colSpan", "label", "loaderProps", "look", "tdProps"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React from 'react';
import { CircleLoader } from "../../loader/circle-loader/circle-loader.js";
import "../../loader/shimmer-loader/shimmer-loader.js";
import { Td } from "./td.js";
import { Tr } from "./tr.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * `<tr>` which shows `<CircleLoader>`.
 * @param props TrLoaderProps
 * @returns FunctionComponent<TrLoaderProps>
 */
var TrLoader = function TrLoader(props) {
  var breakpoints = props.breakpoints,
    className = props.className,
    colSpan = props.colSpan,
    label = props.label,
    loaderProps = props.loaderProps,
    look = props.look,
    tdProps = props.tdProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Tr, _extends({}, otherProps, {
    breakpoints: breakpoints,
    className: classnames(_defineProperty({
      'bf-table__standard-tr-loader': true
    }, "".concat(className), !!className)),
    look: look
  }), /*#__PURE__*/React.createElement(Td, _extends({}, tdProps, {
    breakpoints: breakpoints,
    colSpan: colSpan
  }), /*#__PURE__*/React.createElement(CircleLoader, _extends({}, loaderProps, {
    label: label
  }))));
};
export { TrLoader };